export default function Stats() {
  const stats = [
    { icon: 'ri-trophy-fill', value: '500+', label: 'Successful Projects', color: 'from-yellow-500 to-orange-500' },
    { icon: 'ri-team-fill', value: '350+', label: 'Happy Clients', color: 'from-blue-500 to-cyan-500' },
    { icon: 'ri-award-fill', value: '50+', label: 'Industry Awards', color: 'from-purple-500 to-pink-500' },
    { icon: 'ri-global-fill', value: '25+', label: 'Countries Served', color: 'from-green-500 to-emerald-500' }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center group cursor-pointer">
              <div className={`inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br ${stat.color} mb-4 group-hover:scale-110 transition-transform`}>
                <i className={`${stat.icon} text-3xl text-white`}></i>
              </div>
              <div className="text-4xl font-bold text-gray-900 mb-2">{stat.value}</div>
              <div className="text-gray-600">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
